import React from 'react';
import NativeView from "react-native-web/dist/exports/View";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import PropTypes from 'prop-types';
import { useTheme } from '../../ThemeProvider';

/**
 * Identical to React Native's View and supporting all the same props, but with:
 *  - a zIndex: 'auto' style added to prevent unexpectedly causing children to overlap other elements from other stacking contexts
 */
import { jsx as _jsx } from "react/jsx-runtime";
const BaseView = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    style,
    ...rest
  } = _ref;
  const {
    themeOptions
  } = useTheme();
  const styleProp = Array.isArray(style) ? [...style] : [style];
  if (!themeOptions.forceZIndex) {
    styleProp.unshift(styles.resetZIndex);
  }
  return /*#__PURE__*/_jsx(NativeView, {
    ...rest,
    style: styleProp,
    ref: ref,
    children: children
  });
});
BaseView.displayName = 'BaseView';
const styles = StyleSheet.create({
  resetZIndex: {
    zIndex: 'auto'
  }
});
BaseView.propTypes = {
  children: PropTypes.node,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};
export default BaseView;